import { render, staticRenderFns } from "./StoreProfile.vue?vue&type=template&id=0066149e&scoped=true&"
import script from "./StoreProfile.vue?vue&type=script&lang=js&"
export * from "./StoreProfile.vue?vue&type=script&lang=js&"
import style0 from "./StoreProfile.vue?vue&type=style&index=0&id=0066149e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066149e",
  null
  
)

export default component.exports